<template>
    <div>
        <b-card no-body class="submission">
            <template #header>
                <h6 class="mb-0">{{ title }}</h6>
            </template>
            <b-list-group flush v-if="!busy">
                <span v-if="submissions != null && submissions.length > 0">
                    <home-submission-item v-for="(item,index) in submissions" :model="item" :key="index" @click.native="goToMenu(item)" />
                </span>
                <app-no-data-image v-else width="100%" imgSrc="no-submission.png" imageClass="w-sm-75 w-50" />
            </b-list-group>
            <b-list-group flush v-else>
                <b-list-group-item>
                    <b-skeleton width="85%" class="mb-1"></b-skeleton>
                </b-list-group-item>
                <b-list-group-item>
                    <b-skeleton width="85%" class="mb-1"></b-skeleton>
                </b-list-group-item>
                <b-list-group-item>
                    <b-skeleton width="85%" class="mb-1"></b-skeleton>
                </b-list-group-item>
            </b-list-group>
        </b-card>
    </div>
</template>
<script>
import HomeSubmissionItem from './HomeSubmissionItem.vue';
import RoleDetail from '@/models/Core/RoleDetail';

export default {
    components: {HomeSubmissionItem},
    props: {
        title : {
            type: String,
            default: '-',
        },
        submissions: {
            type: Array,
            default: [],
        },
        busy : {
            type: Boolean,
            default: false
        }
    },
    methods: {
        goToMenu(item) {
            let roleDetails = RoleDetail.query().where('functionInfoId', item.functionId).with("functionInfo").with("functionInfo.moduleInfo").orderBy("orderPosition").get();
            if (roleDetails != null && roleDetails.length > 0) {
                let roleDetail = roleDetails[0];
                if (roleDetail.functionInfo != null) {
                    this.$router.push(roleDetail.functionInfo.uri + '/inbox?submission=1');
                }
            }
        },
    }
}
</script>